import clsx from 'clsx'
import type { DetailedHTMLProps, FunctionComponent, InputHTMLAttributes } from 'react'
import { Icon, IconName } from './Icon'
import { InputLabel, InputLabelProps } from './InputLabel'
import styles from './InputPassword.module.sass'

export type InputPasswordProps = Pick<
	DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>,
	| 'id'
	| 'name'
	| 'type'
	| 'autoComplete'
	| 'value'
	| 'onChange'
	| 'disabled'
	| 'readOnly'
	| 'placeholder'
	| 'required'
> & {
	label?: InputLabelProps
	iconDecoration?: IconName
	align?: 'left' | 'center'
}

export const InputPassword: FunctionComponent<InputPasswordProps> = ({
	id,
	name,
	autoComplete,
	value,
	onChange,
	disabled,
	readOnly,
	placeholder,
	required,
	label,
	iconDecoration,
	align = 'left',
}) => {
	return (
		<div className={styles.wrapper}>
			<InputLabel {...label} isRequired={required}>
				<div className={styles.main}>
					<input
						id={id}
						className={clsx(styles.input, styles[`is_aligned_${align}`])}
						name={name}
						type="password"
						autoComplete={autoComplete}
						readOnly={readOnly}
						placeholder={placeholder}
						value={value}
						onChange={onChange}
						disabled={disabled}
						required={required}
					/>
					{iconDecoration && (
						<span className={styles.icon}>
							<Icon name={iconDecoration} />
						</span>
					)}
				</div>
			</InputLabel>
		</div>
	)
}
